module.exports = __webpack_public_path__ + "static/media/ResumePrachiSharma.741dc488.pdf";